/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import DropdownItemComponent from './DropdownItemComponent';
import getAssocsFromSessionStorage from '../helpers/sessionHandler';

class DropdownComponent extends React.Component {
  static availableFromSessionStorage(assocs) {
    const ssAssocs = getAssocsFromSessionStorage();
    let found = 0;
    for (let i = 0; i < assocs.length; i += 1) {
      if (ssAssocs.filter((x) => x === assocs[i].ID).length > 0) {
        found = assocs[i].ID;
        break;
      }
    }

    return found;
  }

  constructor(props) {
    super(props);

    const ssAssoc = DropdownComponent.availableFromSessionStorage(
      props.grouping.DataListAssociations,
    );

    const assocs = [{
      ID: 0,
      Name: props.grouping.Name,
      Selected: ssAssoc === 0,
    }];

    props.grouping.DataListAssociations.forEach((assoc) => {
      assocs.push({
        ID: assoc.ID,
        Name: assoc.Name,
        Selected: ssAssoc === assoc.ID,
      });
    });

    this.state = {
      assocs,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.reset) {
      const { assocs } = prevState;
      assocs.forEach((a) => {
        if (a.ID === 0) {
          a.Selected = true;
        } else {
          a.Selected = false;
        }
      });
      return {
        assocs,
      };
    }
    return null;
  }

  handleChange(assoc) {
    const { assocs } = this.state;
    const {
      setActive,
      index,
      active,
      dropDownSearch,
    } = this.props;
    const clearArr = [];
    let currentSelected = 0;
    assocs.forEach((a) => {
      if (a.Selected) {
        currentSelected = a.ID;
      }
    });

    clearArr.push(currentSelected);
    clearArr.push(DropdownComponent.availableFromSessionStorage(assocs));

    setActive(index === active ? 0 : index);

    if (index === active) {
      dropDownSearch(assoc, clearArr);
    }

    assocs.forEach((a) => {
      a.Selected = a.ID === assoc;
    });

    this.setState({ assocs });
  }

  render() {
    const { assocs } = this.state;
    const { index, active } = this.props;
    const assocNodes = assocs.map((assoc, i) => {
      const key = i;
      return (
        <DropdownItemComponent
          key={key}
          assoc={assoc}
          handleChange={this.handleChange}
        />
      );
    });
    let classNames = 'gym-dropdown resetlist';
    if (index === active) {
      classNames += ' open';
    }
    return (
      <ul className={classNames}>
        {assocNodes}
      </ul>
    );
  }
}

const DataListGroupingsShape = PropTypes.shape({});

const AssociationContainersShape = PropTypes.shape({
  Associations: PropTypes.arrayOf(PropTypes.shape({
    Active: PropTypes.bool.isRequired,
    DataListGroupings: DataListGroupingsShape.isRequired,
    DataListItems: DataListGroupingsShape.isRequired,
    GroupID: PropTypes.number.isRequired,
    ID: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
  }).isRequired),
  ID: PropTypes.number.isRequired,
  Name: PropTypes.string.isRequired,
});

DropdownComponent.propTypes = {
  active: PropTypes.number.isRequired,
  dropDownSearch: PropTypes.func.isRequired,
  grouping: PropTypes.shape({
    Active: PropTypes.bool.isRequired,
    AssociationContainers: PropTypes.arrayOf(AssociationContainersShape).isRequired,
    DataList: PropTypes.number,
    DataListAssociations: PropTypes.arrayOf(AssociationContainersShape).isRequired,
    GroupOrder: PropTypes.number.isRequired,
    ID: PropTypes.number.isRequired,
    List: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  reset: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
};

DropdownComponent.displayName = 'DropdownComponent';
export default DropdownComponent;
